export { default } from '@/components/results/result-timing-cell'
